export type SessionUser = {
  userId?: string;
  role?: string;
  email?: string;
  phone?: string;
  countryCode?: string;
};

export type LoginSuccessPayload = {
  token?: string;
  accessToken?: string;
  refreshToken?: string | null;
  userId?: string;
  role?: string;
  email?: string;
  phone?: string;
};

const K = { access: "authToken", user: "authUser" } as const;

export const session = {
  getAccess(): string | null {
    return sessionStorage.getItem(K.access);
  },
  getUser(): SessionUser | null {
    const raw = sessionStorage.getItem(K.user);
    return raw ? (JSON.parse(raw) as SessionUser) : null;
  },
  save({ accessToken, user }: { accessToken: string; user?: SessionUser }) {
    sessionStorage.setItem(K.access, accessToken);
    if (user) sessionStorage.setItem(K.user, JSON.stringify(user));
  },
  clear() {
    sessionStorage.removeItem(K.access);
    sessionStorage.removeItem(K.user);
    sessionStorage.removeItem("refreshToken");
    try {
      window.dispatchEvent(new CustomEvent("auth:logout"));
    } catch {}
  },
};
